<!--
Important:
This Component is used only for the Vue3 application
Any modifications made should be done for Vue2 component also
Vue2File:wwwroot\js\ParagonGroup\components\DealerHours\HeaderDealerHours.vue
Dont forget to make the changes in both the files
Any clarifications contact divya
-->
<template>
  <div class="header-dealer-hours-section">
    <div class="text-right mr-2 mb-2"><em class="primaryicon-times ft-12" @click="closeHours()" /></div>
    <business-hours />
  </div>
</template>
<script>
import businessHours from "./ClassicFooterDealerHours.vue";
export default {
  components: {
    businessHours
  },
  methods:{
    closeHours() {
      this.$emit('closehours');
    },
  }
}
</script>

<style>
  .header-dealer-hours-section {
    max-width: 40%;
    min-width: 750px;
    background: #fff;
    height: 50vh !important;
    padding: 30px;
    font-size: 12px;
    overflow: hidden;
    position: absolute;
    right: -30px;
    top: 70px;
    box-shadow: -1px 1px 10px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.06);
    border-radius: 15px;
    z-index: 99;
    color: #333;
  }
  .dealer-hours-container {
    display: flex !important;
    gap: 20px;
    flex-wrap: wrap;
    overflow: scroll;
  }
  .department-hours {
    flex: 0 0 calc(33.3% - 20px);
    margin: 0 !important;
  }
  .header-dealer-hours-section .lightbackground2-primary {
    display: none !important;
  }
  .header-dealer-hours-section .dealer-icon h3 {
    font-size: 1rem !important;
  }
  .header-dealer-hours-section .current-day {
    font-size: 12px !important;
  }
  .header-dealer-hours-section .holiday-hours {
    flex: 0 0 calc(50% - 20px);
  }
</style>
